import { Flex } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export const DangerZoneRow = ({ children }: Props) => {
  return (
    <Flex flexDirection={{ base: 'column', md: 'row' }} alignItems="start" justifyContent="space-between" columnGap="8" rowGap="2">
      {children}
    </Flex>
  );
};
